export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon3.url-1fef9edd9a2d18da3c602302e3e29c9c.svg";